export const columns = function () {
  return [
    {
      prop: 'id',
      label: 'ID',
      minWidth: 50
    },
    {
      prop: 'num',
      label: '期数',
      minWidth: 100
    },
    {
      prop: 'showtime',
      label: '公示日期',
      minWidth: 50,
    },
    {
      prop: 'cartnum',
      label: '分摊车辆',
      minWidth: 50,
    },
    {
      prop: 'eventnum',
      label: '事件数量',
      minWidth: 50,
    },
    {
      prop: 'status',
      label: '状态',
      minWidth: 50,
    },
    {
      prop: 'createtime',
      label: '创建时间',
      minWidth: 50,
    },
    {
      prop: 'moneys',
      label: '本期车损出险金额',
      minWidth: 50,
    },
    {
      prop: 'szmoneys',
      label: '本期三者出险金额',
      minWidth: 50,
    },
    {
      prop: 'people',
      label: '承担人数',
      minWidth: 50,
    },
    {
      prop: "handle",
      label: "操作",
      minWidth: 50,
    },
  ]
}


export default {}